import { type GetReferralsResponse } from "../../api/useGetReferrals";
import { type ReferralDetails } from "../../types";
import { BaseReferralStatusCard } from "./BaseReferralStatusCard";

interface PaidReferralCardProps {
  referral: GetReferralsResponse[0];
  outgoingReferralDetails: ReferralDetails;
}

export function PaidReferralCard(props: PaidReferralCardProps) {
  const { referral, outgoingReferralDetails } = props;
  const { bonusValue: bonusAmountReceived } = referral;

  const {
    bonusAmount: bonusAmountForSharing,
    workRequirementMessageThirdPerson: workRequirementMessageThirdPersonForSharing,
  } = outgoingReferralDetails;

  return (
    <BaseReferralStatusCard
      intent="success"
      title={`You earned $${bonusAmountReceived} from a referral sent to you.`}
      description={
        bonusAmountForSharing > 0
          ? `Keep spreading the love by sharing your referral link, and earn a $${bonusAmountForSharing} bonus when a referred friend ${workRequirementMessageThirdPersonForSharing}.`
          : ""
      }
      illustration="pay"
    />
  );
}
